import RuleActionModel from '@/common/models/rules/actions/rule-action-model';
import ScheduleInstructionModel from '@/common/models/rules/schedule-instruction-model';
import _ from '@/common/helpers';

export default class SchedulePaymentActionModel extends RuleActionModel {
    hydrate(fields = {}) {
        super.hydrate(fields);
        const {scheduleInstruction = null, amountPolicy = null} = fields;
        // https://github.com/Rebilly/frontend-recomm/pull/365#pullrequestreview-162962374
        this.scheduleInstruction = new ScheduleInstructionModel(scheduleInstruction || undefined);
        this.amountPolicy = amountPolicy;
    }

    static AmountPolicies = {
        invoiceAmountDie: 'invoice-amount-due',
    };

    get summary() {
        return `Schedule payment ${this.scheduleInstruction.summary} using the ${_.unKebabCase(this.amountPolicy, false)}.`;
    }

    getPayload() {
        return {
            ...super.getPayload(),
            scheduleInstruction: this.scheduleInstruction.getPayload(),
            amountPolicy: this.amountPolicy,
        };
    }
}
